import gql from 'graphql-tag';

// Fragment for pagination info, used in any paginated query.
export const PAGINATOR_FRAGMENT = gql`
  fragment PaginatorParts on PaginatorInfo {
    currentPage
    total
    perPage
    count
    lastPage
  }
`;

// A detailed fragment for the Student type.
export const STUDENT_FRAGMENT = gql`
  fragment StudentDetails on Student {
    id
    first_name
    surname
    other_name
    matric_no
    gender
    email
    dob
    phone
    home_address
    nationality
    city
    state
    photo
    is_active
    currentClassroomSection {
      id
      name
      classroom {
        id
        name
      }
    }
    academicCalendars {
      started_at
      id

      termStructure {
        id
        name
      }
      session {
        id
        name
        sessionStructure {
          id
          name
        }
      }
    }




  }
`;

// A detailed fragment for the Student type.
export const FACULTY_FRAGMENT = gql`
  fragment FacultyDetails on FacultyType {
    id
    faculty_name
    school_id
    type
    is_active
    createdAt
    updatedAt
  }
`;

// A fragment for an Academic Calendar, used in school and bill queries.
const ACADEMIC_CALENDAR_FRAGMENT = gql`
  fragment AcademicCalendarDetails on AcademicCalendar {
    id
    is_active
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
    total_school_days
    started_at
    ended_at
  }
`;

// A comprehensive fragment for a Bill and its nested details.
// This fragment itself uses another fragment (StudentDetails)!
const BILL_FRAGMENT = gql`
  fragment BillDetails on Bill {
    id
    amount
    due_date
    status
    billable_type
    billable_id
    created_at
    billable {
      __typename
      ... on Student {
        ...StudentDetails
      }
      ... on Classroom {
        id
        name
      }
      ... on ClassroomSection {
        id
        name
        classroom {
          id
          name
        }
      }
      ... on FormSubmission {
        id
        tracking_code
        applicant_name
      }
      ... on TranscriptRequest {
        id
        request_applicant_name: applicant_name
        request_tracking_code: tracking_code
      }
    }
    billDetails {
      id
      amount
      billItemTemplate {
        id
        name
        default_amount
        description
      }
    }
    session {
      id
      name
    }
    academicCalendar {
      id
      termStructure {
        id
        name
      }
    }
  }
  ${STUDENT_FRAGMENT}
`;

const STUDENT_BILLS_FRAGMENT = gql`
  fragment StudentBillsDetails on Student {
    studentBills {
      id
      amount
      due_date
      status
      paymentStatusDetails {
        balance
      }
      derivedAdjustments {
        bill_detail_id
        source
        label
        amount
      }
      billDetails {
        id
        amount
        billItemTemplate {
          name
        }
      }
    }
  }
`;

export { ACADEMIC_CALENDAR_FRAGMENT, BILL_FRAGMENT, STUDENT_BILLS_FRAGMENT };
